import React, { useState, useCallback } from 'react';
import ModalContentBase from '../modal/hooks/modal_content_base';
import {
  TEXT,
  HEADING_LARGE,
  HEADING_MEDIUM,
  HEADING_SMALL,
  IMAGE,
  INSTAGRAM,
  YOUTUBE,
  FREE,
  DELETE,
  COURSE,
} from './const';

const TypeSelect = ({
  isCoursesDisplayed,
  onChangeType,
  content,
  isEnterSection,
  deleteContent,
  userAgent,
}) => {
  // TODO SP版の修正
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDroppedDown, setIsDroppedDown] = useState(false);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleModalClick = (type) => {
    if (type === DELETE) {
      deleteContent();
    } else {
      onChangeType(type);
    }
    setIsModalOpen(false);
  };

  const handleSelectChange = (e) => {
    if (e.target.value === DELETE.toString()) {
      deleteContent();
    } else {
      onChangeType(Number(e.target.value));
    }
    setIsDroppedDown(false);
  };

  return (
    <div
      className="mt-3 pt-1 position-relative"
      onMouseLeave={() => userAgent === 'pc' && setIsDroppedDown(false)}
    >
      <img
        id=""
        className="cursor-pointer"
        src="/assets2019/img/icon_plus.svg"
        width="32"
        height="32"
        alt=""
        onClick={() => {
          if (userAgent === 'pc') {
            setIsDroppedDown((prev) => !prev);
          } else {
            setIsModalOpen(true);
          }
        }}
      />
      {isDroppedDown ? (
        <div
          className="p-0 select-dropdown-menu"
          style={{
            width: '100px',
            top: '16px !important',
            left: '20px !important',
          }}
        >
          <select
            id="content_type"
            onClick={(e) => {
              handleSelectChange(e);
            }}
            className="p-2 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
            size={isEnterSection ? '7' : '8'}
          >
            <option className="form-option" value={TEXT}>
              本文
            </option>
            <option className="form-option" value={HEADING_LARGE}>
              大見出し
            </option>
            <option className="form-option" value={HEADING_MEDIUM}>
              中見出し
            </option>
            <option className="form-option" value={HEADING_SMALL}>
              小見出し
            </option>
            <option className="form-option" value={IMAGE}>
              画像
            </option>
            <option className="form-option" value={INSTAGRAM}>
              Instagram
            </option>
            <option
              className="form-option"
              value={YOUTUBE}
              style={{ border: isEnterSection ? 'none' : '' }}
            >
              Youtube
            </option>
            {isCoursesDisplayed ? (
              <option value={COURSE}>コース挿入</option>
            ) : (
              <React.Fragment />
            )}
            {!isEnterSection && (
              <option
                className="form-option"
                style={{ border: 'none' }}
                value={DELETE}
              >
                削除
              </option>
            )}
          </select>
        </div>
      ) : null}
      {userAgent !== 'pc' && isModalOpen ? (
        <ModalContentBase
          closeModal={() => closeModal()}
          modalContent={
            <div className="card bg-gray pt-3">
              <button
                type="button"
                className="close close__modal position-absolute position--modalclose"
                aria-label="Close"
                onClick={() => closeModal()}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h6 className="text-fw-bold text-center mb-3_5">
                コンテンツタイプを選択してください
              </h6>
              <div className="card bg-white">
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(TEXT);
                  }}
                >
                  本文
                </div>
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(HEADING_LARGE);
                  }}
                >
                  大見出し
                </div>
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(HEADING_MEDIUM);
                  }}
                >
                  中見出し
                </div>
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(HEADING_SMALL);
                  }}
                >
                  小見出し
                </div>
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(IMAGE);
                  }}
                >
                  画像
                </div>
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(YOUTUBE);
                  }}
                >
                  Youtube
                </div>
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(INSTAGRAM);
                  }}
                >
                  Instagram
                </div>
                {isCoursesDisplayed ? (
                  <div
                    className="p-3"
                    onClick={() => {
                      handleModalClick(COURSE);
                    }}
                  >
                    コース挿入
                  </div>
                ) : null}
                {!isEnterSection && (
                  <div
                    className="p-3"
                    onClick={() => {
                      handleModalClick(DELETE);
                    }}
                  >
                    削除
                  </div>
                )}
              </div>
            </div>
          }
        />
      ) : null}
    </div>
  );
};

export default TypeSelect;
